import { ACCOUNT_NOT_ACTIVE } from '../UserAuthStates/constants';
export const localeMapping = (text) => {
    const dict = new Map([
        ['User is disabled.', ACCOUNT_NOT_ACTIVE],
        ['User is not confirmed.', ACCOUNT_NOT_ACTIVE],
    ]);
    return dict.get(text) || text;
};
//# sourceMappingURL=localeMapping.js.map